import { netsparkAxios } from 'core/services/HTTPService';
import getUserManagementListUrl from './apiUrls';

const getUserManagementLis = (signal, params) => netsparkAxios
  .get(getUserManagementListUrl, { signal, params });

export default getUserManagementLis;
